import styled from "styled-components";

const Label = styled.label`
  color: #000000;
  font-size: 18px;
  font-weight: 600;
`;

export default Label;
